<template>
    <div class="page-title-area bg-10">
        <div class="container">
            <div class="page-title-content">
                <h2>Sign In</h2>
                <ul>
                    <li>
                        <router-link to="/">
                            Home 
                        </router-link>
                    </li>
                    <li class="active">Sign In</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PageTitle'
}
</script>